<template lang="html">
   <form :class="classBinding" @submit.prevent="isValid()">
      <div class="form-content" :class="form.class" v-for="form in forms">
         <label 
            v-if="form.label && form.type !== 'checkbox' && form.type != 'button' && form.type != 'upload'"
            class="form-label" 
         >{{form.label}}</label>
         <label 
            v-if="form.type !== 'checkbox' && form.type != 'button' && form.type != 'upload' && form.sub_label"
            class="small-label" 
         >{{form.sub_label}}</label>
         
         <InputText
            v-if="form.type === 'text'"
            :name="form.model"
            :prepend="form.prepend"
            :append="form.append"
            :type="form.form_type"
            :model="formData_[form.model]"
            v-model="formData_[form.model]"
            :action="form.name"
            :disabled="form.disabled"
            :placeholder="form.placeholder"
            @input="validateItem(form)"
         />

         <Select 
            v-if="form.type === 'select'"
            v-model="formData_[form.model]" 
            :multiple="form.multiple || false" 
            :clearable="form.clearable || true" 
            :filterable="form.filterable || false"
            :max-tag-count="form.max_tag_count || 3"
            @input="onSelectChange(form)"
         >
            <Option v-for="(item,index) in form.options" :value="item.val" :key="index">{{ item.label }}</Option>
         </Select>

         <Mobile 
            v-if="form.type === 'mobile'"
            v-model="formData_[form.model]"
            @input="validateItem(form)"
            :placeholder="form.placeholder"
         />

         <button 
            v-if="form.type === 'button'"
            class="btn form-btn" 
            :class="form.btnClass"
            @click="btnClick(form.model)"
         >{{form.label}}</button>

         <TextArea
            v-if="form.type === 'textarea'"
            :name="form.model"
            v-model="formData_[form.model]"
            :action="form.name"
            :rows="form.rows"
            :placeholder="form.placeholder"
            @input="validateItem(form)"
         />

         <Checkbox
            v-if="form.type === 'checkbox'"
            :name="form.model"
            v-model="formData_[form.model]"
            :action="form.name"
            :label="form.label"
            @change="validateItem(form)"
         />

         <DatePicker 
            v-if="form.type === 'datepicker'"
            :type="form.form_type || 'date'" 
            :value="formData_[form.model]" 
            :format="form.format || 'dd-MM-yyyy'" 
            :placement="form.placement || 'bottom-end'" 
            :placeholder="form.placeholder"
            :start-date="form.start_date || new Date()"
            @on-change="handleChange($event,form)">
         </DatePicker>

         <TimePicker 
            v-if="form.type === 'timepicker'"
            :type="form.form_type || 'time'" 
            :value="formData_[form.model]" 
            :format="form.format || 'HH:mm'" 
            :placement="form.placement || 'bottom-end'" 
            :placeholder="form.placeholder"
            :steps="form.steps || [1,5]"
            @on-change="handleChange($event,form)">
         </TimePicker>

         <Radio
            v-if="form.type === 'radio'"
            :classes="form.classes"
            :name="form.model"
            v-model="formData_[form.model]"
            :action="form.name"
            :placeholder="form.placeholder"
            :options="form.options"
            @input="validateItem(form)"
         />

         <Upload 
            v-if="form.type === 'upload'"
            :label="form.label"
            :name="form.model"
            :accept="form.accept" 
            :multiple="form.multiple" 
            v-model="formData_[form.model]"
            @file-selected="forwardEvent('file-selected',$event)"
         />

         <ColorPicker 
            v-if="form.type === 'color'"
            v-model="formData_[form.model]" 
            :hue="form.hue || true" 
            :alpha="form.alpha || false"
            :recommend="form.recommend || false"
            :colors="form.colors"
            @on-change="validateItem(form)"
         />

         <Rate 
            v-if="form.type === 'rate'"
            v-model="formData_[form.model]" 
            :allow-half="form.allow_half || false"
            :icon="form.icon"
            :character="form.character"
            @input="validateItem(form)"
         />

         <Slider 
            v-if="form.type === 'slider'"
            v-model="formData_[form.model]" 
            :step="form.step" 
            :min="form.min || 0" 
            :max="form.max || 100"
            :show-stops="form.show_stops"
            :range="form.range"
            :marks="form.marks"
            @on-change="validateItem(form)"
         ></Slider>

         <Location
            v-if="form.type === 'location'"
            :model="formData_[form.model]" 
            :placeholder="form.placeholder" 
            v-model="formData_[form.model]"
            @on-change="validateItem(form)"
         ></Location>

         <FormTable
            v-if="form.type === 'form-table'" 
            :table="form.table" 
            :forms="form.forms" 
            v-model="formData_[form.model]"
         />

         <CheckboxGroup
            v-if="form.type === 'checkbox-group'"
            :classes="form.classes"
            :name="form.model"
            v-model="formData_[form.model]"
            :action="form.name"
            :placeholder="form.placeholder"
            :options="form.options"
            :model="formData_[form.model]"
            @input="validateItem(form)"
         />

         <label 
            v-if="form.type !== 'checkbox' && form.type != 'button' && form.type != 'upload' && form.sub_label_bottom"
            class="small-label-bottom" 
         >{{form.sub_label_bottom}}</label>
         <!-- Validation Error -->
         <div class="form-err">{{form.err}}</div>
      </div>
   </form>
</template>

<script>
import {Select, Option, OptionGroup} from './select/'
import {TimePicker} from './date-picker/index'

export default {
   created(){
      Event.$on('remote:receivedData',(payload) => {
         if(payload.formName === this.name){
            this.remoteData[payload.name] = payload.data
         }
      })
   },
   components: {
      Checkbox: () => import("./checkbox"),
      CheckboxGroup: () => import("./checkbox-group"),
      Radio: () => import("./radio"),
      Label: () => import("./label"),
      TextArea: () => import("./textarea"),
      InputText: () => import("./text"),
      ColorPicker: () => import("./color-picker/index"),
      DatePicker: () => import("./date-picker/index"),
      Slider: () => import("./slider/index"),
      Rate: () => import("./rate/index"),
      Upload: () => import("./upload"),
      Location: () => import("./location"),
      FormTable: () => import("./form-table"),
      Mobile: () => import("./mobile"),
      Select,
      Option,
      OptionGroup,
      TimePicker
   },
   props: {
      forms: {
         type: Array,
         default: function(){
            return []
         }
      },
      classBinding: {
         type: String,
         default: ''
      },
      name:{
         type: String,
         default: ''
      },
      formData: {
         type: Object,
         default: function(){
            return {}
         }
      }
   },
   watch:{
      forms(oldVal,newVal){
         this.formData_ = utils.generateFormData(newVal)
      },
      formData(oldVal,newVal){
         console.log('Form Data changed')
      }
   },
   data () {
      return {
         formData_: this.formData,
         hasErrors: false,
         remoteData: {}
      }
   },
   methods: {
      handleSelectChange(data,form){
         if(data){
            this.formData_[form.model] = data
            console.log('Changed data', data)
         }
      },
      initializeRemoteData(){
         for (let i = 0; i < this.forms.length; i++) {
            const form = this.forms[i];
            
            if(form.type === 'remote'){
               this.remoteData = {[form.remoteName]: []}
            }
         }
      },
      resetForms(){
         this.formData_ = utils.generateFormData(this.forms)
      },
      forwardEvent(name,e){
         this.$emit(name,e)
      },
      btnClick(name){
         this.$emit('button-click',{ref: this,name})
      },
      handleChange (date,form) {
         this.formData_[form.model] = date;
         this.validateItem(form)
      },
      onSelectChange(form){
         Event.$emit('select-field-changed',{form,data: this.formData_[form.model]})
         this.validateItem(form)
      },
      async validateItem(form){
         if(form.validation){
            let result = null, err = undefined;

            if(form.type === 'mobile'){
               result = await validate(this.formData_[form.model]['mobile'], form.validation, { name: form.label }), err = undefined
            }else{
               result = await validate(this.formData_[form.model], form.validation, { name: form.label })
            }

            if (!result.valid) {
               this.hasErrors = true
               err = result.errors[0]
            }

            form.err = err
            this.$forceUpdate();
         }
      },
      async isValid() {
         this.hasErrors = false

         for (let i = 0; i < this.forms.length; i++) {
            const form = this.forms[i];
            await this.validateItem(form)
         }

         if(!this.hasErrors){
            this.$emit('submit',this.formData_)
            return true
         }else{
            $notify('warning','Validation Errors','Fix form inputs with errors before proceeding',30)
            return false
         }
      },
   },
   mounted(){
      this.initializeRemoteData()
   }
}
</script>